export default "__VITE_ASSET__BqywySBq__"